import React from 'react';
import chevronRight from '../../styles/img/arrow/vector.svg';
import { useSelector } from 'react-redux';
import { STORE_LIST } from '../../constants/routes';
import { useNavigate } from 'react-router';
import { isAllowToChangeStore } from '../../utils/Validator';

const StoreSelectionButton = ({ originPath }) => {
  const navigate = useNavigate();
  const { store } = useSelector((state) => state.store);

  const onClick = () => {
    if (isAllowToChangeStore(store)) navigate(STORE_LIST, { state: { prevPage: originPath } });

  };

  if (!store) {
    return (<></>);
  }
  return (
    <div className="store-selection-button" onClick={onClick}>
      {isAllowToChangeStore(store) && (
        <div className="store-action">
          <div>Changer de magasin</div>
          <img src={chevronRight} alt="chevronBottom" />
        </div>
      )}
      <div className="store-detail">
        <div className="store-name-content">
          <img src={store.logo} alt="logo" className="store-img" />
          <div className="store-name">{store.name}</div>
        </div>
        <div className="store-city">{store.city}</div>
      </div>
    </div>
  );
};

export default StoreSelectionButton;
